(() => {
  if (customElements.get('pw-cart-shipping')) return;
  const cache = new Map();
  class CartShipping extends HTMLElement {
    connectedCallback() {
      this.drawer = this.closest('cart-drawer');
      if (!this.drawer) return;
      this.observer = new MutationObserver(() => this.refresh());
      this.observer.observe(this.drawer, { attributes: true, attributeFilter: ['class'] });
      this.refresh();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
    }
    async refresh() {
      if (!this.drawer.classList.contains('active') || this.loading) return;
      const key = [this.dataset.countryCode, this.dataset.currency, this.dataset.cartKey].join('|');
      const saved = cache.get(key);
      if (saved && Date.now() - saved.time < 30000) {
        this.show(saved.rates);
        return;
      }
      this.loading = true;
      this.controller = new AbortController();
      const timer = setTimeout(() => this.controller.abort(), 8000);
      try {
        const params = new URLSearchParams({ 'shipping_address[country]': this.dataset.country });
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/shipping_rates.json?${params}`, {
          credentials: 'same-origin', signal: this.controller.signal,
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('Shipping quote unavailable');
        const body = await response.json();
        if (!Array.isArray(body.shipping_rates)) throw new Error('Shipping quote unavailable');
        cache.set(key, { time: Date.now(), rates: body.shipping_rates });
        if (this.isConnected) this.show(body.shipping_rates);
      } catch (error) {
        if (this.isConnected && this.dataset.countryCode !== 'US') this.show([]);
      } finally {
        clearTimeout(timer);
        this.loading = false;
      }
    }
    show(rates) {
      const standard = rates.filter(rate => /standard|ground|sf express/i.test(rate.name || rate.presentment_name || ''));
      const rate = standard.find(rate => Number(rate.price) === 0) || standard[0];
      const free = Boolean(rate && Number(rate.price) === 0);
      const value = this.querySelector('.cart__shipping-value');
      if (value) value.textContent = free ? 'FREE' : 'At checkout';
      const footer = this.closest('.drawer__footer');
      const note = footer?.querySelector('[data-shipping-reassurance]');
      if (note && this.dataset.countryCode !== 'US') {
        note.replaceChildren();
        const title = rate?.name || rate?.presentment_name || '';
        let text = '';
        if (/payable on arrival|unpaid/i.test(title)) text = 'Duties & taxes payable on arrival';
        else if (/duties.*included|duty.*paid/i.test(title)) text = 'No duties or taxes on arrival';
        if (text) {
          const line = document.createElement('p');
          line.className = 'cart__duties-line cart__duties-line--plain';
          line.textContent = text;
          note.append(line);
        }
      }
      const firstBadge = footer?.querySelector('.cart-trust-badge');
      const template = footer?.querySelector(free ? '[data-shipping-badge-free]' : '[data-shipping-badge-paid]');
      if (firstBadge && template) firstBadge.innerHTML = template.innerHTML;
    }
  }
  customElements.define('pw-cart-shipping', CartShipping);
})();
